import { DWGApi } from '../../../../api/Operations/Engineering/DWG'
import DWG from '../../../../components/Operations/Engineering/DWG/DWG'
import React from 'react'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import useTitle from '../../../../elements/Hooks/useTitle'
import useListCompanyFilter from '../../../../elements/Hooks/useListCompanyFilter'

function DWGCont() {
  const { list: cached, fetching, fetch } = useFetchList(() => DWGApi.list())
  const { list, company, onChangeCompany } = useListCompanyFilter(cached, fetching)
  useTitle('DWG')

  return (
    <DWG
      {...{
        list,
        fetching,
        fetch,
        company,
        onChangeCompany,
      }}
    />
  )
}

DWGCont.propTypes = {}
DWGCont.defaultProps = {}

export default DWGCont
